import { addTimestampToFileName, convertDateToDateOnlyString } from '@/core/utils/datetime';
import { blobResponseHandler, downloadBlob } from '@/shared/helpers/api';
import { baseApi } from '@/admin/baseApi';
import { t } from '@/core/localization';
// export const api = baseApi.enhanceEndpoints({ addTagTypes: ['PriceList', 'Articles'] }).injectEndpoints({
export const api = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCustomersDebt: builder.query({
            query: ({ reportDate, customerIds }) => ({
                method: 'POST',
                url: 'customer/payment-balance/debt-report',
                body: {
                    reportDate: convertDateToDateOnlyString(reportDate),
                    customerIds,
                },
            }),
        }),
        exportCustomerDebtReportToExcel: builder.mutation({
            queryFn: async ({ reportDate, customerIds }, api, extraOptions, baseQuery) => downloadBlob({
                queryResult: await baseQuery({
                    method: 'POST',
                    cache: 'no-cache',
                    url: 'customer/payment-balance/debt-report/excel',
                    body: {
                        reportDate: convertDateToDateOnlyString(reportDate),
                        customerIds,
                    },
                    responseHandler: blobResponseHandler,
                }),
                fileName: `${t('file.name.customer.debt.report')} ${addTimestampToFileName()}.xlsx`,
            }),
        }),
    }),
});
export const { useGetCustomersDebtQuery, useExportCustomerDebtReportToExcelMutation } = api;
export { api as customerDebtReportApi };
